"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _HeaderDaten = _interopRequireDefault(require("./HeaderDaten"));
var _HeaderResponse = _interopRequireDefault(require("./HeaderResponse"));
var _SortenProduktKonditionen = _interopRequireDefault(require("./SortenProduktKonditionen"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The SortenKonditionen model module.
 * @module model/SortenKonditionen
 * @version 1.0.44
 */
var SortenKonditionen = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>SortenKonditionen</code>.
   * Konditionen für Sorten
   * @alias module:model/SortenKonditionen
   * @implements module:model/HeaderResponse
   * @param header {module:model/HeaderDaten} 
   * @param hashCode {String} hashcode der Kondition
   * @param defaultSoBpBuyKondition {Number} Default Wert für Verkauf Shop Kondition
   * @param defaultSoBpSellKondition {Number} Default Wert für Ankauf Shop Kondition
   * @param defaultSoWlBuyKondition {Number} Default Wert für Verkauf Kundenshop Kondition
   * @param sortenProduktKonditionen {module:model/SortenProduktKonditionen} 
   */
  function SortenKonditionen(header, hashCode, defaultSoBpBuyKondition, defaultSoBpSellKondition, defaultSoWlBuyKondition, sortenProduktKonditionen) {
    _classCallCheck(this, SortenKonditionen);
    _HeaderResponse.default.initialize(this, header);
    SortenKonditionen.initialize(this, header, hashCode, defaultSoBpBuyKondition, defaultSoBpSellKondition, defaultSoWlBuyKondition, sortenProduktKonditionen);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(SortenKonditionen, null, [{
    key: "initialize",
    value: function initialize(obj, header, hashCode, defaultSoBpBuyKondition, defaultSoBpSellKondition, defaultSoWlBuyKondition, sortenProduktKonditionen) {
      obj['header'] = header;
      obj['hashCode'] = hashCode;
      obj['defaultSoBpBuyKondition'] = defaultSoBpBuyKondition;
      obj['defaultSoBpSellKondition'] = defaultSoBpSellKondition;
      obj['defaultSoWlBuyKondition'] = defaultSoWlBuyKondition;
      obj['sortenProduktKonditionen'] = sortenProduktKonditionen;
    }

    /**
     * Constructs a <code>SortenKonditionen</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SortenKonditionen} obj Optional instance to populate.
     * @return {module:model/SortenKonditionen} The populated <code>SortenKonditionen</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new SortenKonditionen();
        _HeaderResponse.default.constructFromObject(data, obj);
        if (data.hasOwnProperty('header')) {
          obj['header'] = _HeaderDaten.default.constructFromObject(data['header']);
        }
        if (data.hasOwnProperty('hashCode')) {
          obj['hashCode'] = _ApiClient.default.convertToType(data['hashCode'], 'String');
        }
        if (data.hasOwnProperty('defaultSoBpBuyKondition')) {
          obj['defaultSoBpBuyKondition'] = _ApiClient.default.convertToType(data['defaultSoBpBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('defaultSoBpSellKondition')) {
          obj['defaultSoBpSellKondition'] = _ApiClient.default.convertToType(data['defaultSoBpSellKondition'], 'Number');
        }
        if (data.hasOwnProperty('defaultSoWlBuyKondition')) {
          obj['defaultSoWlBuyKondition'] = _ApiClient.default.convertToType(data['defaultSoWlBuyKondition'], 'Number');
        }
        if (data.hasOwnProperty('sortenProduktKonditionen')) {
          obj['sortenProduktKonditionen'] = _SortenProduktKonditionen.default.constructFromObject(data['sortenProduktKonditionen']);
        }
        if (data.hasOwnProperty('defaultSoMaBuyKondition')) {
          obj['defaultSoMaBuyKondition'] = _ApiClient.default.convertToType(data['defaultSoMaBuyKondition'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SortenKonditionen</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SortenKonditionen</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // check to make sure all required properties are present in the JSON string
      var _iterator = _createForOfIteratorHelper(SortenKonditionen.RequiredProperties),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var property = _step.value;
          if (!data[property]) {
            throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
          }
        }
        // validate the optional field `header`
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (data['header']) {
        // data not null
        _HeaderDaten.default.validateJSON(data['header']);
      }
      // ensure the json data is a string
      if (data['hashCode'] && !(typeof data['hashCode'] === 'string' || data['hashCode'] instanceof String)) {
        throw new Error("Expected the field `hashCode` to be a primitive type in the JSON string but got " + data['hashCode']);
      }
      // validate the optional field `sortenProduktKonditionen`
      if (data['sortenProduktKonditionen']) {
        // data not null
        _SortenProduktKonditionen.default.validateJSON(data['sortenProduktKonditionen']);
      }
      return true;
    }
  }]);
}();
SortenKonditionen.RequiredProperties = ["header", "hashCode", "defaultSoBpBuyKondition", "defaultSoBpSellKondition", "defaultSoWlBuyKondition", "sortenProduktKonditionen"];

/**
 * @member {module:model/HeaderDaten} header
 */
SortenKonditionen.prototype['header'] = undefined;

/**
 * hashcode der Kondition
 * @member {String} hashCode
 */
SortenKonditionen.prototype['hashCode'] = undefined;

/**
 * Default Wert für Verkauf Shop Kondition
 * @member {Number} defaultSoBpBuyKondition
 */
SortenKonditionen.prototype['defaultSoBpBuyKondition'] = undefined;

/**
 * Default Wert für Ankauf Shop Kondition
 * @member {Number} defaultSoBpSellKondition
 */
SortenKonditionen.prototype['defaultSoBpSellKondition'] = undefined;

/**
 * Default Wert für Verkauf Kundenshop Kondition
 * @member {Number} defaultSoWlBuyKondition
 */
SortenKonditionen.prototype['defaultSoWlBuyKondition'] = undefined;

/**
 * @member {module:model/SortenProduktKonditionen} sortenProduktKonditionen
 */
SortenKonditionen.prototype['sortenProduktKonditionen'] = undefined;

/**
 * Default Mitarbeiterkondition für Sorten Verkauf Shop
 * @member {Number} defaultSoMaBuyKondition
 */
SortenKonditionen.prototype['defaultSoMaBuyKondition'] = undefined;

// Implement HeaderResponse interface:
/**
 * @member {module:model/HeaderDaten} header
 */
_HeaderResponse.default.prototype['header'] = undefined;
var _default = exports.default = SortenKonditionen;